import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  IconButton,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useTheme,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import UserInfoPopup from "./UserInfoPopup";

export default function ShraddhaAdminUser() {
  const navigate = useNavigate();
  const [UsersData, setUsersData] = useState([]);
  const [modulesData, setModulesData] = useState([]);
  const token = localStorage.getItem("shraddhatoken");
  const [ShowDialog, setShowDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUserCard, setShowUserCard] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedValue, setSelectedValue] = useState("allUser");
  const arole = localStorage.getItem("arole");
  const theme = useTheme();

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const fetchModulesData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/shraddha/module/list",
        {},
        {
          headers: { Authorization: token },
        }
      );
      setModulesData(Object.values(response.data));
    } catch (error) {
      //console.log(error);
    }
  };

  const [moduleDates, setModuleDates] = useState({});
  const [AdminId, SetAdminId] = useState();

  const EnableModule = async (Row) => {
    SetAdminId(Row.id);
    fetchData(Row.id);
    setShowDialog(true);
  };

  const handleDateChange = (moduleId, field, value) => {
    setModuleDates((prev) => ({
      ...prev,
      [moduleId]: {
        ...prev[moduleId],
        [field]: value,
      },
    }));
  };

  const fetchData = async (id) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/shraddha/module/mymodule",
        { id },
        {
          headers: { Authorization: token },
        }
      );
      const Data = Object.values(response.data);
      const prefilledDates = {};

      Data.forEach((item) => {
        prefilledDates[item.module_Id] = {
          from: item.module_Purchased
            ? item.module_Purchased.split("T")[0]
            : "",
          to: item.module_Expiry ? item.module_Expiry.split("T")[0] : "",
        };
      });

      setModuleDates(prefilledDates);
    } catch (error) {
      console.log(error);
    }
  };

  const HandleSave = async () => {
    const formattedData = modulesData.map((module) => {
      const dates = moduleDates[module.module_Id] || {};
      return {
        admin_Id: AdminId,
        module_Id: module.module_Id,
        module_Purchased: dates.from || "",
        module_Expiry: dates.to || "",
      };
    });

    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/shraddha/module/add",
        formattedData,
        {
          headers: { Authorization: token },
        }
      );
      alert("Module Enabled Successfully...");
      setShowDialog(false);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUsersData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/shraddha/operation/acDisplay",
        {},
        {
          headers: { Authorization: token },
        }
      );

      const users = Object.values(response.data);
      setUsersData(users[0]);
      // console.log(users)
    } catch (error) {
      console.log("Error fetching group data", error);
    }
  };

  useEffect(() => {
    fetchUsersData();
    fetchModulesData();
  }, []);

  const filteredUsers = UsersData.filter((user) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      user.admin_FirstName.toLowerCase().includes(searchLower) ||
      user.admin_LastName.toLowerCase().includes(searchLower) ||
      user.admin_Email.toLowerCase().includes(searchLower) ||
      user.admin_CmpName.toLowerCase().includes(searchLower) ||
      user.admin_Mobile.toString().includes(searchLower)
    );
  });

  const userListRow = filteredUsers.map((user) => ({
    id: user.admin_Id,
    name: user.admin_FirstName + " " + user.admin_LastName,
    email: user.admin_Email,
    CmpName: user.admin_CmpName,
    mibileNumber: user.admin_Mobile,
    Last_Login: user.admin_last_Login,
    originalData: user,
  }));

  const memberListRow = filteredUsers
    .filter((user) => user.member_From && user.member_To)
    .map((user) => ({
      id: user.admin_Id,
      name: `${user.admin_FirstName} ${user.admin_LastName}`,
      email: user.admin_Email,
      CmpName: user.admin_CmpName,
      mibileNumber: user.admin_Mobile,
      Last_Login: user.admin_last_Login,
      originalData: user,
    }));

  const registeredListRow = filteredUsers
    .filter((user) => !user.member_From && !user.member_To)
    .map((user) => ({
      id: user.admin_Id,
      name: `${user.admin_FirstName} ${user.admin_LastName}`,
      email: user.admin_Email,
      CmpName: user.admin_CmpName,
      mibileNumber: user.admin_Mobile,
      Last_Login: user.admin_last_Login,
      originalData: user,
    }));

  const columns = [
    {
      field: "",
      headerName: "Sr No",
      headerAlign: "center",
      align: "center",
      width: 80,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => params.api.getRowIndex(params.id) + 1,
    },
    {
      field: "name",
      headerName: "Name",
      headerAlign: "center",
      align: "center",
      width: 200,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "email",
      headerName: "Email",
      headerAlign: "center",
      align: "center",
      width: 300,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "CmpName",
      headerName: "Company Name",
      headerAlign: "center",
      align: "center",
      width: 200,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "mibileNumber",
      headerName: "Mobile Number",
      headerAlign: "center",
      align: "center",
      width: 150,
      sortable: false,
      disableColumnMenu: true,
    },
    ...(arole !== "sales"
      ? [
          {
            field: "action",
            headerName: "Action",
            headerAlign: "center",
            align: "center",
            width: 150,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
              return (
                <Box>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      EnableModule(params.row);
                    }}
                    sx={{
                      textTransform: "none",
                      boxShadow: "none",
                      backgroundColor: "black",
                      color: "white",
                      padding: "2px 8px", // reduce vertical + horizontal padding
                      minHeight: "28px", // lower overall height
                      fontSize: "0.90rem", // slightly smaller text
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor: "#333",
                      },
                    }}
                  >
                    Add Module
                  </Button>
                </Box>
              );
            },
          },
        ]
      : []),
  ];

  const handleRowClick = (params) => {
    const userData = UsersData.find((user) => user.admin_Id === params.id);
    setSelectedUser(userData);
    setShowUserCard(true);
  };

  const closeUserCard = () => {
    setShowUserCard(false);
    setSelectedUser(null);
  };

  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          paddingTop: 8,
          paddingLeft: 3,
          paddingRight: 3,
          paddingBottom: 0,
          marginLeft: "240px",
          marginTop: 4,
          marginBottom: 0,
          backgroundColor: "#f4f6f7",
          borderRadius: "10px",
          position: "relative",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* User Info Popup */}
        {showUserCard && selectedUser && (
          <UserInfoPopup
            user={selectedUser}
            usersData={UsersData}
            onClose={closeUserCard}
            onEnableModule={EnableModule}
            token={token}
          />
        )}

        {/* Module Dialog */}
        <Dialog
          open={ShowDialog}
          onClose={() => setShowDialog(false)}
          maxWidth="md"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: 2,
            },
          }}
        >
          <DialogTitle
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Manage User Modules</Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setShowDialog(false)}
              sx={{
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ pt: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: theme.palette.action.hover }}>
                  <TableCell sx={{ fontWeight: "bold" }}>Module Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Start Date</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>End Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {modulesData.map((module) => (
                  <TableRow
                    key={module.module_Id}
                    hover
                    sx={{
                      height: 40, // 👈 reduces row height
                      "& .MuiTableCell-root": {
                        padding: "4px 8px", // 👈 tighter padding inside cells
                      },
                    }}
                  >
                    <TableCell>{module.module_Name}</TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        type="date"
                        size="small"
                        value={moduleDates[module.module_Id]?.from || ""}
                        onChange={(e) =>
                          handleDateChange(
                            module.module_Id,
                            "from",
                            e.target.value
                          )
                        }
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiOutlinedInput-input": {
                            padding: "6px 8px", // 👈 makes the input box shorter
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        fullWidth
                        type="date"
                        size="small"
                        value={moduleDates[module.module_Id]?.to || ""}
                        onChange={(e) =>
                          handleDateChange(
                            module.module_Id,
                            "to",
                            e.target.value
                          )
                        }
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: theme.palette.divider,
                            },
                            "&:hover fieldset": {
                              borderColor: theme.palette.primary.main,
                            },
                          },
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>

          <DialogActions
            sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}` }}
          >
            <Button
              variant="outlined"
              onClick={() => setShowDialog(false)}
              sx={{
                mr: 1,
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={HandleSave}
              sx={{
                backgroundColor: "#000000",
                "&:hover": {
                  backgroundColor: theme.palette.success.dark,
                },
              }}
            >
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>

        {/* Main Content */}
        <Box
          sx={{
            width: "100%",
            height: "calc(100% - 64px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h2" sx={{ fontWeight: "bold", width: "100%" }}>
              User Management
            </Typography>

            <Box
              sx={{
                width: "80%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 2,
              }}
            >
              <FormControl
                size="small"
                sx={{
                  width: "20%",
                  minWidth: 180,
                }}
              >
                <InputLabel>Filter Users</InputLabel>
                <Select
                  value={selectedValue}
                  onChange={handleSelectChange}
                  label="Filter Users"
                >
                  <MenuItem value="allUser">All Users</MenuItem>
                  <MenuItem value="member">Members Only</MenuItem>
                  <MenuItem value="registered">Registered Only</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  width: "200px",
                  "& .MuiInputBase-input": {
                    color: "black", // Input text color
                  },
                  "& .MuiInputLabel-root": {
                    color: "black", // Label text color
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "black", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "black", // Hover border color
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "black", // Focused border color
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        sx={{
                          color: "black",
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>

          <Typography variant="body2" sx={{ mb: 1, fontStyle: "italic" }}>
            Please click on the table row for details.
          </Typography>

          <Box
            height="74vh"
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
                "& .MuiDataGrid-cell": {
                  borderBottom: `1px solid ${theme.palette.divider}`,
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: theme.palette.background.default,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: theme.palette.background.paper,
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: `1px solid ${theme.palette.divider}`,
                  backgroundColor: theme.palette.background.default,
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              },
            }}
          >
            <DataGrid
              rows={
                selectedValue === "allUser"
                  ? userListRow
                  : selectedValue === "registered"
                  ? registeredListRow
                  : memberListRow
              }
              columns={columns}
              disableColumnSort={true}
              onRowClick={handleRowClick}
              rowHeight={35}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
